import { PortalTierEnum } from '@app/services/api/api.types';
import { State, StateService } from '@app/services/state/state.service';

export type CheckoutPathKind = 'option' | 'upsell';

/** Query value for `bundle` — must match `buildPortalSignInRedirectUrl` / resume handling. */
export const CHECKOUT_BUNDLE_RESTORE_QUERY_VALUE = '1';

/** Query value for BASIC tier — no `PortalTierEnum` value exists for the base plan. */
export const CHECKOUT_BASIC_TIER_QUERY_VALUE = 'base';

export function urlRequestsBundleRestore(url: URL): boolean {
  return url.searchParams.get('bundle') === CHECKOUT_BUNDLE_RESTORE_QUERY_VALUE;
}

/** Restore ancillary / tier selections from post-login query string into `StateService`. */
export function patchCheckoutStateFromUrl(url: URL, stateService: StateService) {
  const patch: Partial<State> = {};
  const leadPortalLink = url.searchParams.get('portalLink');

  if (leadPortalLink) {
    patch.portalLink = leadPortalLink;
  }

  const dp = url.searchParams.get('disruptionProtection');

  if (dp != null && dp !== '') {
    const n = Number(dp);

    if (!Number.isNaN(n) && n > 0) {
      patch.disruptionProtection = n;
    }
  }

  const cfar = url.searchParams.get('cancelForAnyReason');

  if (cfar != null && cfar !== '') {
    const n = Number(cfar);

    if (!Number.isNaN(n) && n > 0) {
      patch.cancelForAnyReason = n;
    }
  }

  if (urlRequestsBundleRestore(url)) {
    patch.bundleRestorePending = true;
  }

  const tierParam = url.searchParams.get('tier');

  if (tierParam === CHECKOUT_BASIC_TIER_QUERY_VALUE) {
    patch.tier = undefined;
    patch.basicTierSelected = true;
  } else if (tierParam) {
    const allowed = Object.values(PortalTierEnum) as string[];

    if (allowed.includes(tierParam)) {
      patch.tier = tierParam as PortalTierEnum;
      patch.basicTierSelected = false;
    }
  }

  if (Object.keys(patch).length) {
    stateService.patchState(patch);
  }
}
